/**
 * @file RouterHelpers.ts
 * @module _admin/helpers/RouterHelpers
 * @description Provides the RouterHelpers helper used for asset resolution, routing, sample data, and React compatibility support.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0];
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname);
  if (!current || !url) {
    return false;
  }

  if (current === url) {
    return true;
  }

  // Absolute paths match from the start, so /dashboard is not active on /procurement/master/dashboard.
  if (url.startsWith('/')) {
    const base = url.replace(/\/+$/, '');
    return current === base || current.startsWith(`${base}/`);
  }

  // Relative menu paths, such as warehouse/all-warehouse, can sit anywhere in the path.
  return current.indexOf(url) > -1;
}
